import CrmAnalyticsPage from "../features/crm/CrmAnalyticsPage";

export default function CrmAnalyticsRoute() {
  return <CrmAnalyticsPage />;
}
